import { render } from "./UserEmailAccountsPanel.vue?vue&type=template&id=085e7722&scoped=true"
import script from "./UserEmailAccountsPanel.vue?vue&type=script&lang=js"
export * from "./UserEmailAccountsPanel.vue?vue&type=script&lang=js"

import "./UserEmailAccountsPanel.vue?vue&type=style&index=0&id=085e7722&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085e7722"]])

export default __exports__